import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';

const GeneralSliceSelectors = (state: RootState) => state.general;

export const selectGeneralMessages = createSelector(
  GeneralSliceSelectors,
  (state) => state.appMessages,
);

export const selectAllTranslations = createSelector(
  GeneralSliceSelectors,
  (state) => state.translations,
);

export const selectAllPageContents = createSelector(
  GeneralSliceSelectors,
  (state) => state.pageContents,
);

export const selectTranslationsCount = createSelector(
  GeneralSliceSelectors,
  (state) => state.translationsCount,
);

export const selectTranslationsPendingStatus = createSelector(
  GeneralSliceSelectors,
  (state) => state.translationsIsPending,
);

export const selectTemporaryLanguage = createSelector(
  GeneralSliceSelectors,
  (state) => state.temporaryLanguage,
);

export const selectSupportEmails = createSelector(
  GeneralSliceSelectors,
  (state) => state.supportEmails,
);

export const selectSupportsEmailsPendingStatus = createSelector(
  GeneralSliceSelectors,
  (state) => state.supportEmailsIsPending,
);

export const selectAdminPanelPrevTab = createSelector(
  GeneralSliceSelectors,
  (state) => state.adminPanelTabsPrevTab,
);

export const selectIsExportPending = createSelector(
  GeneralSliceSelectors,
  (state) => state.isExportPending,
);

export const selectIsPaymentButtonPending = createSelector(
  GeneralSliceSelectors,
  (state) => state.paymentButtonIsPending,
);
